export default __webpack_public_path__ + "static/Tablet-718eed214332d69c02ff0ba98ebb13b9.png";